import React from "react"
import { projectChainId } from "../constants/config"

export const connectWallet = async () => {
  const chainId = projectChainId;

  if (window.ethereum) {
    try {
      const chain = await window.ethereum.request({ method: "eth_chainId" })
      if (parseInt(chain, 16) == chainId) {
        const addressArray = await window.ethereum.request({
          method: "eth_requestAccounts",
        })
        if (addressArray.length > 0) {
          return {
            address: addressArray[0],
            status: "👆🏽 Your wallet is connected to the site.",
          }
        } else {
          return {
            address: "",
            status: "😥 Connect your wallet account to the site.",
          }
        }
      } else {
        window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: chainId }],
        })
        return {
          address: "",
          status: "😥 You are using the wrong network. Scales is on the Ethereum blockchain. Please select the Ethereum mainnet in your wallet and try again.",
        }
      }
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      }
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            You need a web3 wallet to mint. Please install metamask and try again.
            (<a href="https://metamask.io/download.html" style={{color: "black"}}>https://metamask.io/download.html</a>)
          </p>
        </span>
      ),
    }
  }
}

export const getCurrentWalletConnected = async () => {
  
  const chainId = projectChainId;

  if (window.ethereum) {
    try {
      const addressArray = await window.ethereum.request({
        method: "eth_accounts",
      })
      const chain = await window.ethereum.request({
        method: "eth_chainId",
      })
      if ( addressArray.length > 0 && chain === chainId) {
        return {
          address: addressArray[0],
        }
      } else {
        return {
          address: "",          
          status:
            "🦊 Connect to Metamask and choose the correct chain using the top right button.",
        }
      }
    } catch (err) {
      return {
        address: "",
        status: "😥 " + err.message,
      }
    }
  } else {
    return {
      address: "",
      status: (
        <span>
          <p>
            {" "}
            🦊{" "}
            You need a web3 wallet to mint. Please install metamask and try again.
            (<a href="https://metamask.io/download.html" >https://metamask.io/download.html</a>)
          </p>
        </span>
      ),
    }
  }
}
